<script>

import ChatService from "@/services/ChatService";
import CreateEmotionDialog from "@/views/master/systemconfig/chat/emotion/dialog/CreateEmotionDialog.vue";
import UpdateEmotionDialog from "@/views/master/systemconfig/chat/emotion/dialog/UpdateEmotionDialog.vue";

const headerCellStyle = () => {
  return {
    backgroundColor: "#78a5e7",
    color: "#fff",
  }
}

export default {
  components: {UpdateEmotionDialog, CreateEmotionDialog},
  computed: {
    sortedDataTableEmotion() {
      return [...this.dataTableEmotion].sort((a, b) => {
        if (a.active !== b.active) {
          return a.active === true ? -1 : 1;
        }
        return a.order - b.order;
      });
    }
  },

  data() {
    return {
      isLoading: false,
      dataInit: [],
      dataTableEmotion: [],
      isOpenDialog: {
        create: false,
        update: false,
      },

      filter: {
        page: 1,
        limit: 10,
        search: "",
        total: 0,
      },
      listPageSizes: [10, 30, 40, 50, 100, 200, 500],
      countIconActive: 0,

      isEditOrder: false,
    }
  },

  watch: {},

  created() {
    this.fetchDataIcons();
  },

  methods: {
    headerCellStyle,
    handleOpenCreateDialog() {
      this.isOpenDialog.create = true;
    },

    handleUpdateEmotion(data) {
      this.$refs.updateEmotionDialog.initialDataUpdate(data);
      this.isOpenDialog.update = true;
    },

    handleSelectionChange(value) {
      this.selectionMultiple = value;
    },

    /**
     * Xử lý API lấy tất cả icon
     * */
    fetchDataIcons() {
      ChatService.emotionService.getAll(this.filter.page, this.filter.limit, this.filter.search)
          .then((res) => {
            let response = res.data;

            // Thêm tempActive vào mỗi phần tử
            this.countIconActive = response.data.content.filter(item => item.active).length;
            this.dataInit = response.data.content;
            this.dataTableEmotion = this.dataInit.map((item) => ({
              ...item,
              tempActive: item.active,
              tempIsDefault: item.isDefault,
              tempOrder: item.order,
            }));

            this.filter.total = response.total;
          })
          .catch((err) => {
            console.log(err);
          });
    },

    /**
     * Gọi API cập nhật sử dụng icon
     * */
    fetchUpdateActive(value, data) {
      return ChatService.emotionService
          .updateActive(data)
          .then((res) => {
            const dataNew = res.data.data;
            if (dataNew !== null) {
              this.handleSuccessUpdate(dataNew);
              if (!value) {
                this.handleUpdateOrder(data);
              }
              this.$message({message: res.data.message, type: "success"});
              return true; // Trả về true nếu API thành công
            }
            return false;
          })
          .catch((err) => {
            console.log(err);
            this.$message.error("Đã có lỗi xảy ra, vui lòng thử lại!");
            return false; // Trả về false nếu API thất bại
          });
    },

    /**
     * Gọi API cập nhật icon mặc định
     * */
    fetchUpdateDefault(value, data) {
      return ChatService.emotionService
          .updateDefault(data)
          .then((res) => {
            const dataNew = res.data.data;
            if (dataNew !== null) {
              this.handleSuccessUpdate(dataNew);
              if (!value) {
                this.handleUpdateDefault(data);
              }
              this.$message({message: res.data.message, type: "success"});
              return true; // Trả về true nếu API thành công
            }
            return false;
          })
          .catch((err) => {
            console.log(err);
            this.$message.error("Đã có lỗi xảy ra, vui lòng thử lại!");
            return false; // Trả về false nếu API thất bại
          });
    },

    handleFilterData() {
      this.fetchDataTags();
    },

    handleSizeChange(value) {
      this.filter.limit = value;
      this.fetchDataTags();
    },

    handleCurrentPageChange(value) {
      this.filter.page = value;
      this.fetchDataTags();
    },

    fetchDelete(data) {
      ChatService.emotionService.delete([data.idIcon])
          .then((res) => {
            this.handleSuccessDelete(data.idIcon);
            this.$message({message: res.data.message, type: "success"});
          })
          .catch((err) => {
            console.log(err);
            this.$message({message: err.message, type: "error"});
          })
    },

    handleSuccessCreated(data) {
      this.dataTableEmotion.push({...data, tempActive: data.active, tempIsDefault: data.isDefault});
      this.isOpenDialog.create = false;
    },

    handleSuccessUpdate(data) {
      const index = this.dataTableEmotion.findIndex((e) => e.idIcon === data.idIcon);
      if (index !== -1) {
        this.$set(this.dataTableEmotion, index, {...data, tempActive: data.active, tempIsDefault: data.isDefault});
      }
      this.isOpenDialog.update = false;
    },

    handleUpdateOrder(data) {
      this.dataTableEmotion = this.dataTableEmotion.map((item) => {
        if (item.order > data.order) {
          return {
            ...item,
            order: item.order - 1,
          };
        }
        return item;
      });
    },

    handleUpdateDefault(data) {
      this.dataTableEmotion = this.dataTableEmotion.map((item) => {
        if (item.idIcon === data.idIcon) {
          return {
            ...item,
            isDefault: true,
            tempIsDefault: true,
          };
        }
        return {
          ...item,
          isDefault: false,
          tempIsDefault: false,
        };
      });
    },


    handleSuccessDelete(ids) {
      const idList = Array.isArray(ids) ? ids : [ids];
      this.dataTableEmotion = this.dataTableEmotion.filter(
          item => !idList.includes(item.idIcon)
      );
    },

    async onChangeActive(value, row) {
      // Gọi API
      const success = await this.fetchUpdateActive(value, row);
      if (success) {
        // Cập nhật active nếu API thành công
        row.active = value;
        row.tempActive = value;
      } else {
        // Hoàn nguyên tempActive nếu API thất bại
        this.$set(row, "tempActive", row.active);
      }
    },

    async onChangeIsDefault(value, row) {
      const success = await this.fetchUpdateDefault(value, row);
      if (success) {
        row.isDefault = value;
        row.tempIsDefault = value;
        if (value) {
          this.handleUpdateDefault(row);
        }
      } else {
        this.$set(row, "tempIsDefault", row.isDefault);
      }
    },

    deleteIcon(data) {
      this.$confirm(`Bạn có chắc muốn xoá emotion "${data.key}" không? <br/> Sẽ không thể hoàn tác!`, "Thông báo!", {
        dangerouslyUseHTMLString: true,
        distinguishCancelAndClose: true,
        confirmButtonText: "Có",
        closeOnClickModal: false,
        cancelButtonText: "Không",
        type: "warning",
      })
          .then(async () => {
            this.fetchDelete(data);
          })
    },

    handleIsEditOrder() {
      this.resetTempOrder();
      this.isEditOrder = !this.isEditOrder;
    },

    resetTempOrder() {
      this.dataTableEmotion.forEach((item) => {
        if (item.active) {
          item.tempOrder = item.order;
        }
      })
    },

    getIconOrder(order) {
      for (let data in this.dataInit) {
        if (data.order === order) {
          return data;
        }
      }
    },

    handleChangeOrder(newOrder, rowData) {
      const oldOrder = rowData.order;

      // Nếu không thay đổi thì bỏ qua
      if (oldOrder === newOrder) {
        return;
      }

      // Tìm item đang giữ newOrder
      const conflictItem = this.dataTableEmotion.find(
          (item) => item.tempOrder === newOrder
      );

      if (conflictItem) {
        // Thằng này phải nhường về vị trí cũ của rowData
        conflictItem.tempOrder = oldOrder;
      }

      // Cập nhật order mới cho rowData
      rowData.tempOrder = newOrder;
    }
  }
}
</script>

<template>
  <div>
    <!-- Bộ lọc -->
    <section>
      <el-row type="flex">
        <!--      <el-col :span="20">-->
        <!--        <el-row type="flex" :gutter="4">-->

        <!--          <el-col :span="3">-->
        <!--            <el-select-->
        <!--                v-model="dataFilter.statusActive"-->
        <!--                placeholder="Trạng thái phiếu" style="width: 100%"-->
        <!--                @change="handleFilterData"-->
        <!--                :clearable="true"-->
        <!--            >-->
        <!--              <el-option-->
        <!--                  v-for="(item, index) in optionsStatusForm"-->
        <!--                  :key="index"-->
        <!--                  :label="item.label"-->
        <!--                  :value="item.value"-->
        <!--              >-->
        <!--              </el-option>-->
        <!--            </el-select>-->
        <!--          </el-col>-->


        <!--          <el-col :span="6">-->
        <!--            <el-date-picker-->
        <!--                style="width: 100%"-->
        <!--                v-model="dataFilter.dateRange"-->
        <!--                type="daterange"-->
        <!--                range-separator="-"-->
        <!--                start-placeholder="Thời gian tạo"-->
        <!--                end-placeholder="Thời gian tạo"-->
        <!--                format="dd/MM/yyyy"-->
        <!--                value-format="yyyy-MM-dd"-->
        <!--                @change="handleFilterData"-->
        <!--            >-->
        <!--            </el-date-picker>-->
        <!--          </el-col>-->

        <!--          <el-col :span="3">-->
        <!--            <el-select-->
        <!--                v-model="dataFilter.type"-->
        <!--                placeholder="Loại phiếu" style="width: 100%"-->
        <!--                @change="handleFilterData"-->
        <!--                :clearable="true"-->
        <!--            >-->
        <!--              <el-option-->
        <!--                  v-for="(item, index) in optionsTypeApply"-->
        <!--                  :key="index"-->
        <!--                  :label="item.label"-->
        <!--                  :value="item.value"-->
        <!--              >-->
        <!--              </el-option>-->
        <!--            </el-select>-->
        <!--          </el-col>-->

        <!--          <el-col :span="6">-->
        <!--            <el-input-->
        <!--                :clearable="true"-->
        <!--                style="width: 100%"-->
        <!--                placeholder="Nhập tiêu đề hoặc mã phiếu"-->
        <!--                v-model="dataFilter.name"-->
        <!--                @keyup.enter.native="handleFilterData"-->
        <!--                @clear="handleFilterData"-->
        <!--            >-->
        <!--              <template #append>-->
        <!--                <el-button-->
        <!--                    icon="el-icon-search"-->
        <!--                    @click="handleFilterData"-->
        <!--                ></el-button>-->
        <!--              </template>-->
        <!--            </el-input>-->
        <!--          </el-col>-->

        <!--          <el-col :span="1">-->
        <!--            <el-button-->
        <!--                style="-->
        <!--                    width: 100%;-->
        <!--                    padding-left: 10px;-->
        <!--                    padding-right: 10px;"-->
        <!--                plain-->
        <!--                :type="isAdvancedFilter ? 'danger' : 'primary'"-->
        <!--                @click="handleOpenAdvancedFilter"-->
        <!--                :icon="'el-icon-circle-plus'"/>-->
        <!--          </el-col>-->

        <!--          <el-col :span="1" v-if="isAdvancedFilter">-->
        <!--            <el-button-->
        <!--                style="-->
        <!--                    width: 100%;-->
        <!--                    padding-left: 10px;-->
        <!--                    padding-right: 10px;"-->
        <!--                type="danger"-->
        <!--                plain-->
        <!--                @click="handleResetAdvancedFilter"-->
        <!--                :icon="'el-icon-refresh-left'"/>-->
        <!--          </el-col>-->

        <!--        </el-row>-->
        <!--      </el-col>-->

        <el-col :span="4">
          <!--          <el-row type="flex" :justify="'end'">-->
          <el-row type="flex">
            <el-col :span="11">
              <el-button style="width: 100%" type="success" @click="handleOpenCreateDialog">
                <i class="el-icon-plus"/>
                Thêm mới
              </el-button>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </section>

    <!-- Phần bảng quản lý -->
    <section>
      <div style="margin: 20px 0">
        <el-table
            ref="tableSurveyForm"
            element-loading-spinner="el-icon-loading"
            :data="sortedDataTableEmotion"
            border
            :max-height="$tableMaxHeight"
            :header-cell-style="headerCellStyle"
            :element-loading-text="$tableLoading"
            @selection-change="handleSelectionChange"
            element-loading-background="rgba(255,255,255, 0)"
            v-loading="isLoading"
        >
          <!--          <el-table-column-->
          <!--              type="selection"-->
          <!--              width="50"-->
          <!--              align="center"-->
          <!--          />-->

          <el-table-column
              type="index"
              label="STT"
              width="50"
              align="center"
          />

          <el-table-column
              label="Ngày tạo"
              width="160"
              align="center"
          >
            <template v-slot:default="scope">
              <span>{{ scope.row.createdDate | formatDateTime }}</span>
            </template>
          </el-table-column>

          <el-table-column
              label="Mã emotion"
              width="180"
              align="center"
          >
            <template v-slot:default="scope">
              <span style="text-transform: uppercase">{{ scope.row.idIcon }}</span>
            </template>
          </el-table-column>

          <el-table-column
              label="Tên"
          >
            <template v-slot:default="scope">
              <span>{{ scope.row.name }}</span>
            </template>
          </el-table-column>

          <el-table-column
              label="Emotion"
              width="160"
              align="center"
          >
            <template v-slot:default="scope">
              <span>{{ scope.row.key }}</span>
            </template>
          </el-table-column>

          <el-table-column
              width="150"
              align="center"
          >
            <template #header>
              <div>
                <span>Thứ tự</span>
                <el-button circle type="text" size="medium" @click="handleIsEditOrder">
                  <i v-if="!isEditOrder" class="el-icon-edit" style="color: #e0e0e0"></i>
                  <i v-else class="el-icon-close" style="color: #e0e0e0"></i>
                </el-button>
              </div>
            </template>

            <template v-slot:default="scope">
              <el-input-number v-if="scope.row.active && isEditOrder" style="width: 90px" size="mini"
                               v-model="scope.row.tempOrder" controls-position="right"
                               @change="(order) => handleChangeOrder(order, scope.row)" :min="1"
                               :max="countIconActive"></el-input-number>

              <span v-else style="white-space: pre-line">{{ scope.row.order }}</span>
            </template>
          </el-table-column>

          <el-table-column
              label="Sử dụng"
              width="150"
              align="center"
          >
            <template v-slot:default="scope">
              <span>
                <el-checkbox v-model="scope.row.tempActive" @change="(data) => onChangeActive(data, scope.row)"/>
              </span>
            </template>
          </el-table-column>

          <el-table-column
              label="Mặc định"
              width="150"
              align="center"
          >
            <template v-slot:default="scope">
              <span>
                <el-checkbox :disabled="scope.row.isDefault || !scope.row.active" v-model="scope.row.isDefault"
                             @change="(data) => onChangeIsDefault(data, scope.row)"/>
              </span>
            </template>
          </el-table-column>

          <el-table-column
              label="Tác vụ"
              width="240"
              align="center"
          >
            <template v-slot:default="scope">
              <div>
                <el-button @click="handleUpdateEmotion(scope.row)" size="small" type="success">
                  Sửa
                </el-button>

                <el-button @click="deleteIcon(scope.row)" size="small" type="danger">
                  Xoá
                </el-button>
              </div>
            </template>
          </el-table-column>

          <template #empty>
            <div style="text-align: center; font-size: 16px; color: #43a0ff;">
              <i class="el-icon-warning"></i>
              <span> Không có dữ liệu! </span>
            </div>
          </template>
        </el-table>
      </div>
    </section>

    <section>
      <el-row type="flex" justify="center">
        <el-col :span="4">
          <div class="">
            <el-pagination
                background
                layout="prev, pager, next, sizes"
                @size-change="handleSizeChange"
                @current-change="handleCurrentPageChange"
                :current-page.sync="filter.page"
                :page-sizes="listPageSizes"
                :total="filter.total">
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </section>

    <!-- Dialog -->
    <section>
      <CreateEmotionDialog
          :is-open="isOpenDialog.create"
          @closeDialog="isOpenDialog.create = false"
          @success="handleSuccessCreated"
      />

      <UpdateEmotionDialog
          :is-open="isOpenDialog.update"
          @closeDialog="isOpenDialog.update = false"
          @success="handleSuccessUpdate"
          ref="updateEmotionDialog"
      />
    </section>
  </div>
</template>

<style scoped lang="scss">

</style>